import { defineStore } from 'pinia'

export const useFeatureToggleStore = defineStore('feature-toggle', () => {
  const featuresEnabledConfigMap = ref({
    /** 偏好設定 */
    preferences: {
      enabled: false,
    },
    /** 更多相似類別 */
    relatedTags: {
      enabled: false,
    },
  })

  const isPreferencesEnabled = computed(() => featuresEnabledConfigMap.value.preferences.enabled)
  const isRelatedTagsEnabled = computed(() => featuresEnabledConfigMap.value.relatedTags.enabled)

  return {
    featuresEnabledConfigMap,
    isPreferencesEnabled,
    isRelatedTagsEnabled,
  }
})
